export abstract class Base64 {

  public static isBase64(str: string): boolean {
    let isBase64 = false;

    try {
      window.atob(str.replace('data:image/jpeg;base64,', ''));
      isBase64 = true;
    } catch (e) { }

    return isBase64;
  }

  public static getPathFromFileNameOrBase64(image: string, imgServer: string, defaultImg: string): string {
    if (image && !Base64.isBase64(image)) {
      return imgServer + image;
    }
    if (Base64.isBase64(image)) {
      image;
    }
    return defaultImg;
  }
}
